import React, { useState, useRef, useEffect } from 'react'
import styled from 'styled-components' 
import { FiDownload } from "react-icons/fi";
import { Tooltip } from '@mui/material';  
import { icons } from '../icons';
import { useSelector, useDispatch } from 'react-redux';
import { HiOutlineDotsHorizontal } from "react-icons/hi";
import { DroItem, DroTitle } from '../files.styled';
import { CiEdit } from "react-icons/ci";
import { AiOutlineDelete } from "react-icons/ai";
import { TbArrowMoveRight } from "react-icons/tb";
import useToggleDropdown from 'hooks/useToggleDropdown';
import { deleteFile, setSelectedFile, setViewFileModal } from 'features/files/fileSlice';
import { setConfirmModalData, setViewConfirmModal } from 'features/modal/modalSlice';
import { FaExternalLinkAlt } from "react-icons/fa";
import { DotsWrap, IconStyled, DotEle } from 'components/dots/dots.styled';
import { useTranslation } from 'react-i18next'

export default function FileItem({index, id, file}) {
    const { t, i18n } = useTranslation('files')

    const dispatch = useDispatch()
    let fileDate = new Intl.DateTimeFormat(i18n.language).format(new Date(file.createdAt))
    const { widths, newFileName, selectedFolder, isFileDeletedSuccess, isFileDeleting } = useSelector(state => state.file)
    const ref = useRef(null)
    const [isDropped, setIsDropped] = useToggleDropdown(ref)
    const handleDropDown = () => { setIsDropped.toggle(ref) } 

    const {profileChurch} = useSelector(state => state.profileChurch)
    const { user, admin } = useSelector(state => state.auth) 

    const [fileTitle, setFileTitle] = useState(file.title)

    const download = async () => {
        // download using the file path
        //  here we can do some sorting based on file types
        //  for now we will just download the file since all files 
        //  are pdfs for now.
        // in future we will have more file types 

        fetch(file.url).then((response) => {
            response.blob().then((blob) => {  
                const fileURL = window.URL.createObjectURL(blob); 
                let alink = document.createElement("a");
                alink.href = fileURL;
                alink.download = file.title;
                alink.click();
            });
        });
    }

    const handleLink = () => {
        // open link in new tab
        window.open(file.url, '_blank');
    }

    const handleViewPdfURLinNewTab = () => {    
        // open link in new tab
        window.open(file.url, '_blank');
    }

    const handleDelete = () => {

        dispatch(setConfirmModalData({
            text: t('deleteConfirm', { name: fileTitle }),
            handler: confirmDelete,
            confirmBtnBackgroundHover: '#ff0000',
            extraInfo: t('cannotUndo'),
        }))

        dispatch(setViewConfirmModal(true))
    }

    const confirmDelete = () => {
        dispatch(deleteFile({
            churchId: profileChurch._id,
            folderId: selectedFolder ? selectedFolder._id : null,
            fileId: file._id,
        }))
    }

    const handleMove = () => {
        dispatch(setSelectedFile(file))
        dispatch(setViewFileModal({
            modal: 'viewMoveFileModal',
            view: true,
        }))
    }

    const handleRename = () => {
        dispatch(setSelectedFile(file))
        dispatch(setViewFileModal({
            modal: 'viewRenameFileModal',
            view: true,
        }))
    }

    useEffect(() => {
        if(newFileName.id === id){
            setFileTitle(newFileName.value)
        }
    }, [newFileName, id])

    return (
        <FileItemContainer>
            <LeftFileItem> 
                <FileTitle
                    style={{width: `${widths.title}px`}}
                    >
                        {icons[file.fileType]}
                    {fileTitle}
                </FileTitle>              

                <FileDate
                    style={{width: `${widths.date}px`}}
                    >
                    {fileDate}
                </FileDate>

                <FileType
                    style={{width: `${widths.type}px`}}
                    >
                    {file.fileType}
                </FileType>

            </LeftFileItem>

            <RightFileItem> 


                {
                    (admin[profileChurch._id] || user._id === file.creator || user.isOrganization || user._id === profileChurch._id) &&
                    (
                        <>
                            <SBa 
                                style={{marginRight: '20px'}}
                                ref={ref}
                                onClick={handleDropDown}
                                > 
                                <HiOutlineDotsHorizontal size={20} /> 
                            </SBa> 

                    
                            { isDropped && 
                                (
                                    <DotsWrap
                                        top='10px'
                                        right='45px'
                                        >
                                                                                {
                                            // if the file is a pdf allow to view in new tab
                                            
                                            file.fileType === 'pdf' &&
                                            (
                                                <DotEle>
                                                    <IconStyled><FaExternalLinkAlt /></IconStyled>
                                                    <DroTitle onClick={handleViewPdfURLinNewTab}>{t('viewFile')}</DroTitle>
                                                </DotEle>
                                            )
                                            

                                        }
                                        <DotEle>
                                            <IconStyled><TbArrowMoveRight  /></IconStyled>
                                            <DroTitle onClick={handleMove}>{t('moveFile')}</DroTitle>
                                        </DotEle>    
                                        <DotEle>
                                            <IconStyled><CiEdit /></IconStyled>
                                            <DroTitle onClick={handleRename}>{t('renameFile')}</DroTitle>
                                        </DotEle>
                                        <DotEle>
                                            <IconStyled><AiOutlineDelete /></IconStyled>
                                            <DroTitle onClick={handleDelete}>{t('deleteFile')}</DroTitle>
                                        </DotEle>
                                    </DotsWrap>
                                )
                            }
                        </>
                    )
                }


                    {
                        file.url ? 
                        (
                            <Tooltip title={t('goToFile')} placement='top'>
                                <SBa
                                    style={{marginRight: '0px'}}
                                    onClick={handleLink}

                                    >
                                    <FaExternalLinkAlt size={20} /> 
                                </SBa>
                            </Tooltip>     
                        )
                        :
                        (
                            <Tooltip title={t('download')} placement='top'>
                                <SBa
                                    style={{marginRight: '0px'}}
                                    onClick={download}
                                    download 
                                    >
                                    <FiDownload size={20} /> 
                                </SBa>
                            </Tooltip>                              
                        )
                    }


            </RightFileItem> 
        </FileItemContainer>
    )
}


const RightFileItem = styled.div`

    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    width: fit-content;
    position: relative;

`

const FileType = styled.div`
    color: #7b7f82;
    font-weight: 500;

    @media (max-width: 768px) {
        display: none;
    }

`

const FileDate = styled.div`
    color: #7b7f82;
    font-weight: 500;

    @media (max-width: 768px) {
        display: none;
    }

`

const FileItemContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 52px;
    font-size: 13px;
    color: var(--lightThemeFontColor);
    transition: box-shadow 0.25s ease, transform 0.25s ease, border-color 0.25s ease, background-color 0.25s ease;
    cursor: pointer;
    padding: 12px;
    border-radius: 8px;
    border: 1px solid #edf0f2;
    background-color: white;
    box-shadow: 0 2px 10px rgba(61, 70, 78, 0.08);
    margin: 6px 0;

    span{
        margin-top: 5px;
        margin-left: 2px;
        width: 100%;
        text-align: center;
    }

    &:hover{  
        color: #313131;
        border-color: #e0e7eb;
        box-shadow: 0 8px 18px rgba(61, 70, 78, 0.12);
        transform: translateY(-1px);
    }

`

const FileTitle = styled.div`
    width: 400px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis; 
    text-align: left;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    font-weight: 600;

    /* hide overflow text with ellipsis */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    svg{
       color: #8ca7c3;
       margin-right: 15px;
    }
    


    @media (max-width: 768px) {
        width: 200px;
    }

`

const LeftFileItem = styled.div` 
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: fit-content;

    svg{
        font-size: 20px;
        margin-right: 15px; 
    }

`
const SBa = styled.button`
    outline: none;
    border: none;
    background-color: transparent;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: #626b70;
    transition: 0.25s;
    width: 34px;
    height: 34px;
    padding: 0;
    border-radius: 7px;
    background-color: #f7f8fa;

    svg{
        margin: 0px;
        padding: 0px;
        color: #858585;
    }

    &:hover{
        background-color: #eef1f3;
    }

`
